
export interface TrackingData {
  interaction_name?: 'tab_clicked';
  element_name?: string;
  element_order?: number;
  filter_value?: string;
  widget_order?: number;
}

export const mapTitleKeyToElementName = (titleKey: string): string => {
  const mapping: Record<string, string> = {
    'InHouseStats.TabStats': 'stats',
    'InHouseStats.TabOverview': 'overview',
    'InHouseStats.TabPlayers': 'players',
    'InHouseStats.TabLineups': 'lineup',
    'InHouseStats.TabH2H': 'h2h',
  };
  return mapping[titleKey] || titleKey;
};

export const trackInteraction = (tracking: TrackingData) => {
  const {
    interaction_name = null,
    element_name = null,
    filter_value = '',
    widget_order = 1,
    element_order = null,
  } = tracking;

  const widgetData = {
    interaction_name,
    name: 'in_house_stats',
    filter_value,
    content_placement: 'stream_player',
    widget_order,
    element_name,
    element_order,
    page_type: 'sports_event_details_page',
  };

  const message = {
    type: 'kspEvent',
    data: widgetData,
  };

  window.parent.postMessage(message, '*');
};